import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const FinanceManagementHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Upcoming Order List</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default FinanceManagementHeader;
